import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FaJs, FaNodeJs, FaReact } from "react-icons/fa";
import { SiExpress, SiOracle } from "react-icons/si";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import buscamedico from "../../assets/buscamedico.png";
import buscamedicopreto from "../../assets/buscamedicopreto.png";
import guiamedico from "../../assets/guiamedico.png";
import guiamedicoblack from "../../assets/guiamedicopreto.png";
import guiamedicov2 from "../../assets/guiamedicov2.png";
import guiamedicov2black from "../../assets/guiamedicov2black.png";
import rocketnoteslogin from "../../assets/rocketnoteslogin.png";
import rocketnotesregister from "../../assets/rocketnotesregister.png";
import ignitetimer from "../../assets/ignitetimer.png";

const Projects = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedProject, setSelectedProject] = useState(null);

  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const projectList = {
    "Projetos Médicos": [
      {
        title: "Guia Médico",
        images: [guiamedico, guiamedicoblack],
        description:
          "Aplicação para gestão de prontuários e agendamentos médicos na União Médica.",
        technologies: [
          <FaReact key="react" color="#61DBFB" />,
          <FaNodeJs key="nodejs" color="#68A063" />,
          <FaJs key="javascript" color="#F0DB4F" />,
          <SiOracle key="oracle" color="#F80000" />,
          <SiExpress key="express" color="#000000" />,
        ],
        details: `Guia Médico - União Médica
        
O "Guia Médico" é uma plataforma desenvolvida para facilitar a busca por profissionais e estabelecimentos de saúde credenciados pela União Médica. Esta ferramenta permite que os usuários localizem médicos, clínicas e hospitais de forma rápida e eficiente, garantindo acesso a informações detalhadas sobre cada opção disponível.

Funcionalidades Principais:
- Seleção de Plano: Os usuários podem selecionar o plano de saúde específico para visualizar apenas os profissionais e estabelecimentos que atendem ao seu plano.
- Filtro por Especialidade/Procedimento: A plataforma permite a busca por especialidade médica ou tipo de procedimento, ajudando os usuários a encontrar exatamente o que precisam.
- Filtro Geográfico: Os usuários podem filtrar os resultados por estado (UF) e cidade, facilitando a localização de serviços de saúde próximos.
- Tipo de Estabelecimento: A busca pode ser refinada pelo tipo de estabelecimento, como hospitais, clínicas, laboratórios, entre outros.
- Interface Intuitiva: O design da interface é clean e de fácil navegação, garantindo uma experiência de usuário agradável e eficiente.
- Acessibilidade: Todos os filtros são obrigatórios, garantindo que a busca seja sempre precisa e relevante para o usuário.

Benefícios:
- Rapidez e Eficiência: Economiza tempo dos usuários ao reunir todas as informações necessárias em um só lugar.
- Acessibilidade: Facilita o acesso a serviços de saúde, independentemente da localização do usuário.
- Confiabilidade: Oferece informações atualizadas e precisas sobre os profissionais e estabelecimentos credenciados.

O "Guia Médico" da União Médica é uma ferramenta essencial para qualquer beneficiário que busca praticidade e segurança na hora de agendar consultas e procedimentos médicos.`,
      },
      {
        title: "Busca Médico",
        images: [buscamedico, buscamedicopreto],
        description:
          "Portal para pacientes acessarem resultados de exames e histórico médico na União Médica.",
        technologies: [
          <FaReact key="react" color="#61DBFB" />,
          <FaNodeJs key="nodejs" color="#68A063" />,
          <FaJs key="javascript" color="#F0DB4F" />,
          <SiOracle key="oracle" color="#F80000" />,
          <SiExpress key="express" color="#000000" />,
        ],
        details: `Busca Médico - União Médica

O "Busca Médico" é uma ferramenta desenvolvida para facilitar a consulta de profissionais médicos e estabelecimentos de saúde credenciados pela União Médica. Esta plataforma visa oferecer um acesso rápido e direto a informações sobre especialidades e cidades onde os serviços estão disponíveis, promovendo uma experiência de usuário eficiente e simplificada.

Funcionalidades Principais:
- Filtro por Especialidade/Procedimento: Os usuários podem selecionar a especialidade médica ou o procedimento específico que estão procurando, o que facilita encontrar o profissional adequado para suas necessidades.
- Filtro por Cidade: A ferramenta permite a seleção da cidade onde o usuário deseja encontrar o serviço de saúde, garantindo que a busca seja localizada e relevante.
- Consulta de Rede Credenciada: A plataforma fornece informações atualizadas sobre os profissionais e estabelecimentos credenciados, assegurando que os usuários tenham acesso a opções confiáveis e de qualidade.
- Interface Simples e Intuitiva: Com um design clean e amigável, a interface do "Busca Médico" é fácil de navegar, permitindo que os usuários realizem suas buscas de maneira rápida e sem complicações.
- Prioridade de Atendimento: A ferramenta destaca a prioridade de atendimento, ajudando os usuários a escolherem opções que ofereçam um serviço mais ágil e eficiente.

Benefícios:
- Praticidade e Rapidez: Economiza o tempo dos usuários ao reunir todas as informações necessárias em um só lugar.
- Precisão na Busca: Permite uma busca direcionada por especialidade e localização, facilitando a escolha do serviço mais adequado.
- Confiabilidade: Oferece informações precisas e atualizadas sobre a rede credenciada da União Médica.

O "Busca Médico" da União Médica é essencial para os beneficiários que procuram uma maneira prática e eficaz de encontrar profissionais e estabelecimentos de saúde confiáveis.`,
      },
      {
        title: "Guia Médico V2.",
        images: [guiamedicov2, guiamedicov2black],
        description:
          "Aplicação para gestão de prontuários e agendamentos médicos na União Médica.",
        technologies: [
          <FaReact key="react" color="#61DBFB" />,
          <FaNodeJs key="nodejs" color="#68A063" />,
          <FaJs key="javascript" color="#F0DB4F" />,
          <SiOracle key="oracle" color="#F80000" />,
          <SiExpress key="express" color="#000000" />,
        ],
        details: `Guia Médico - União Médica
        
O "Guia Médico" é uma plataforma desenvolvida para facilitar a busca por profissionais e estabelecimentos de saúde credenciados pela União Médica. Esta ferramenta permite que os usuários localizem médicos, clínicas e hospitais de forma rápida e eficiente, garantindo acesso a informações detalhadas sobre cada opção disponível.

Funcionalidades Principais:
- Seleção de Plano: Os usuários podem selecionar o plano de saúde específico para visualizar apenas os profissionais e estabelecimentos que atendem ao seu plano.
- Filtro por Especialidade/Procedimento: A plataforma permite a busca por especialidade médica ou tipo de procedimento, ajudando os usuários a encontrar exatamente o que precisam.
- Filtro Geográfico: Os usuários podem filtrar os resultados por estado (UF) e cidade, facilitando a localização de serviços de saúde próximos.
- Tipo de Estabelecimento: A busca pode ser refinada pelo tipo de estabelecimento, como hospitais, clínicas, laboratórios, entre outros.
- Interface Intuitiva: O design da interface é clean e de fácil navegação, garantindo uma experiência de usuário agradável e eficiente.
- Acessibilidade: Todos os filtros são obrigatórios, garantindo que a busca seja sempre precisa e relevante para o usuário.

Benefícios:
- Rapidez e Eficiência: Economiza tempo dos usuários ao reunir todas as informações necessárias em um só lugar.
- Acessibilidade: Facilita o acesso a serviços de saúde, independentemente da localização do usuário.
- Confiabilidade: Oferece informações atualizadas e precisas sobre os profissionais e estabelecimentos credenciados.

O "Guia Médico" da União Médica é uma ferramenta essencial para qualquer beneficiário que busca praticidade e segurança na hora de agendar consultas e procedimentos médicos.`,
      },
    ],
    "Outros Projetos": [
      {
        title: "Rocket Notes",
        images: [rocketnoteslogin, rocketnotesregister],
        description: "Aplicação para anotações de uma forma bem eficiente.",
        technologies: [
          <FaReact key="react" color="#61DBFB" />,
          <FaNodeJs key="nodejs" color="#68A063" />,
          <FaJs key="javascript" color="#F0DB4F" />,
          <SiExpress key="express" color="#000000" />,
        ],
        details: `Rocket Notes é uma aplicação desenvolvida para ajudar os usuários a salvar e gerenciar seus links úteis de maneira eficiente. Com uma interface amigável, permite criar, visualizar e editar notas facilmente.

Principais funcionalidades:
- Criação de conta e login
- Gerenciamento de notas
- Perfil do usuário
- Interface intuitiva para criar e salvar notas`,
      },
      {
        title: "Ignite Timer",
        images: [ignitetimer],
        description:
          "Aplicação de temporizador para gerenciar o tempo de trabalho de forma eficiente.",
        technologies: [
          <FaReact key="react" color="#61DBFB" />,
          <FaNodeJs key="nodejs" color="#68A063" />,
          <FaJs key="javascript" color="#F0DB4F" />,
          <SiExpress key="express" color="#000000" />,
        ],
        details: `O Ignite Timer é uma aplicação desenvolvida para ajudar profissionais a gerenciar seu tempo de trabalho. Com uma interface simples e intuitiva, o usuário pode definir o nome do projeto, o tempo de trabalho e iniciar o temporizador para acompanhar suas tarefas.

Principais funcionalidades:
- Definir nome do projeto e duração do trabalho
- Visualizar histórico de tarefas concluídas
- Interface amigável e fácil de usar`,
      },
    ],
  };

  const handleOpenModal = (project) => {
    setSelectedProject(project);
    onOpen();
  };

  return (
    <Box py={10}>
      <Heading as="h2" size="xl" mb={6} textAlign="center" color={textColor}>
        Meus Projetos
      </Heading>
      <Tabs isFitted variant="enclosed">
        <TabList mb="1em">
          {Object.keys(projectList).map((category, index) => (
            <Tab key={index}>{category}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {Object.keys(projectList).map((category, index) => (
            <TabPanel key={index}>
              <SimpleGrid columns={[1, null, 3]} spacing={10}>
                {projectList[category].map((project, index) => (
                  <motion.div whileHover={{ scale: 1.05 }} key={index}>
                    <Box
                      borderWidth="1px"
                      borderRadius="lg"
                      overflow="hidden"
                      bg={bgColor}
                      borderColor={borderColor}
                      shadow="md"
                      h="100%"
                      display="flex"
                      flexDirection="column"
                    >
                      <Box display="flex" justifyContent="center" p={2}>
                        {project.technologies.map((icon, index) => (
                          <Box key={index} mx={1} fontSize="xl">
                            {icon}
                          </Box>
                        ))}
                      </Box>
                      <Divider />
                      {project.images.length > 0 && (
                        <Image
                          src={project.images[0]}
                          alt={project.title}
                          h="200px"
                          w="100%"
                          objectFit="cover"
                        />
                      )}
                      <Box p={6} flex="1">
                        <Heading as="h4" size="md" mb={2} color={textColor}>
                          {project.title}
                        </Heading>
                        <Text mb={4} color={textColor}>
                          {project.description}
                        </Text>
                        <Button
                          colorScheme="teal"
                          variant="outline"
                          mt="auto"
                          onClick={() => handleOpenModal(project)}
                        >
                          Ver Mais
                        </Button>
                      </Box>
                    </Box>
                  </motion.div>
                ))}
              </SimpleGrid>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>

      {selectedProject && (
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size="xl"
          scrollBehavior="inside"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color={textColor}>{selectedProject.title}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Carousel showThumbs={false} dynamicHeight>
                {selectedProject.images.map((image, index) => (
                  <div key={index}>
                    <Image
                      src={image}
                      alt={`${selectedProject.title} image ${index + 1}`}
                    />
                  </div>
                ))}
              </Carousel>
              <Box mt={4}>
                {selectedProject.details.split("\n").map((text, index) => (
                  <Text key={index} mb={2} color={textColor}>
                    {text.trim()}
                  </Text>
                ))}
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="teal" mr={3} onClick={onClose}>
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default Projects;
